import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class SimpleStorageService {

    private _storage: Map<string, any> = new Map<string, any>();

    getSimple(key: string) {
        return this._storage.get(key)
    }

    setSimple(key: string, value: any) {
        this._storage.set(key, value);
    }
}